import React, { useEffect } from "react";
import { connect } from "react-redux";

import {
  getGlobalIaac,
  clearAllGlobalIaacMessages
} from "../store/actions";

import { Alert } from "reactstrap";
import { Box, Card, CardContent, Typography, Divider } from "@mui/material";

import accessToken from "../helpers/jwt-token-access/accessToken";
import { jwtDecode } from "jwt-decode";
import GlobalIaaC from "./GlobalIaaC";
import EditGlobalIaaC from "./EditGlobalIaaC";

import spinner from "../assets/images/loadingGif.gif";

const sectionCardSx = {
  mb: 3,
  border: "1px solid #e5eaf2",
  boxShadow: "0 2px 10px rgba(25, 58, 111, 0.06)",
};

const GlobalIaaCManager = (props) => {
  const token = accessToken();
  const decoded = jwtDecode(token);
  const userRole = decoded["cognito:groups"];

  const iaac = props?.iaac;
  useEffect(() => {
    if(!iaac) {
      props.getGlobalIaac();
    }  
  }, [iaac]);


  let getGlobalIaacMessage = props.getGlobalIaacMessage;
  let getGlobalIaacError = props.getGlobalIaacError;
  useEffect(() => {
    console.log("getGlobalIaacMessage = " + getGlobalIaacMessage);
    if (getGlobalIaacMessage || getGlobalIaacError) {
      console.log("Inside if, getGlobalIaacMessage = " + getGlobalIaacMessage);
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000);
    }
  }, [getGlobalIaacMessage, getGlobalIaacError, props]);

  let updateGlobalIaacMessage = props.updateGlobalIaacMessage;
  let updateGlobalIaacError = props.updateGlobalIaacError;
  useEffect(() => {
    console.log("updateGlobalIaacMessage = " + updateGlobalIaacMessage);
    if (updateGlobalIaacMessage || updateGlobalIaacError) {
      console.log("Inside if, updateGlobalIaacMessage = " + updateGlobalIaacMessage);
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000);
    }
    if(updateGlobalIaacMessage){
      props.clearAllMessages();
      props.getGlobalIaac();
    }
  }, [updateGlobalIaacMessage, updateGlobalIaacError, props]);
  

  return (
    <Box
      sx={{
        mt: 2,
        mx: "auto",
        px: { xs: 2, md: 3 },
        width: "100%",
        maxWidth: "1200px",
        boxSizing: "border-box",
      }}
    >
      {props.getGlobalIaacMessage && (
        <Alert className="mt-3 mb-0" color="success">
          {props.getGlobalIaacMessage}
        </Alert>
      )}
      {props.getGlobalIaacError && (
        <Alert className="mt-3 mb-0" color="danger">
          Error while getting License information.
          {JSON.stringify(props.getGlobalIaacError)}
        </Alert>
      )}
      {props.updateGlobalIaacMessage && (
        <Alert className="mt-3 mb-0" color="success">
          {props.updateGlobalIaacMessage}
        </Alert>
      )}
      {props.updateGlobalIaacError && (
        <Alert className="mt-3 mb-0" color="danger">
          Error while getting License information.
          {JSON.stringify(props.updateGlobalIaacError)}
        </Alert>
      )}

      {props.isGettingGlobalIaac && !iaac && (
        <div
          style={{
            display: "flex",
            direction: "column",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <img src={spinner} width="32px" alt="Spinner" />
        </div>
      )}

      {iaac && (
        <Card elevation={0} sx={sectionCardSx}>
          <CardContent sx={{ p: { xs: 2, md: 3 }, "&:last-child": { pb: { xs: 2, md: 3 } } }}>
            <Typography
              variant="h6"
              align="center"
              sx={{ color: "#193a6f", fontWeight: 600, mb: 1 }}
            >
              Global IaaC Management
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <GlobalIaaC iaac={iaac}/>
          </CardContent>
        </Card>
      )}

      {iaac && (
        <Card elevation={0} sx={sectionCardSx}>
          <CardContent sx={{ p: { xs: 2, md: 3 }, "&:last-child": { pb: { xs: 2, md: 3 } } }}>
            <Typography
              variant="h6"
              align="center"
              sx={{ color: "#193a6f", fontWeight: 600, mb: 1 }}
            >
              Edit Global IaaC
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <EditGlobalIaaC iaac={iaac}/>
          </CardContent>
        </Card>
      )}
    </Box>
  );

}

const mapStateToProps = (state) => {
  const {
    isGettingGlobalIaac,
    getGlobalIaacMessage,
    getGlobalIaacError,
    iaac,

    updateGlobalIaacMessage,
    updateGlobalIaacError

  } = state.globalIaac;
  return {
    isGettingGlobalIaac,
    getGlobalIaacMessage,
    getGlobalIaacError,
    iaac,

    updateGlobalIaacMessage,
    updateGlobalIaacError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getGlobalIaac: () => {
      dispatch(getGlobalIaac());
    },
    clearAllMessages: () => {
      dispatch(clearAllGlobalIaacMessages());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalIaaCManager);
